import { Observable, Subscription } from 'common/barrels/rx';
import { blockBusy } from 'common/dom/block';
import { IDisposable } from 'common/disposable';
import { IEventAggregator } from 'common/eventaggregator';
import { Event } from 'common/event';

export function wire<T>($element: JQuery, obs: Observable<T>, subscribe: (o: Observable<T>, e: JQuery) => Subscription, before?: (e: JQuery) => void, after?: (e: JQuery) => void) {
    const subscription = new Subscription();

    const unsubscribe = () => subscription.unsubscribe();

    const uo = Observable.using(() => ({
        unsubscribe: () => {
            $element.off('remove', unsubscribe);
            if (after)
                after($element);

        }
    }), () => obs);

    $element.on('remove', unsubscribe);

    if (before)
        before($element);

    subscription.add(subscribe(uo, $element));

    return $element;
}

export function wireBusy<T>($element: JQuery, obs: Observable<T>, subscribe: (x: Observable<T>, y: JQuery) => Subscription) {
    let busy: IDisposable = null;
    return wire($element, obs, subscribe, e => busy = blockBusy(e), () => busy.dispose());
}

export function bindDisplay($element: JQuery, obs: Observable<boolean>): JQuery {
    return wire($element, obs, o => o.subscribe(x => {
        if (x === true)
            $element.show();
        else
            $element.hide();
    }));
}

export function bindStyle($element: JQuery, obs: Observable<boolean>, trueClass: string, falseClass?: string): JQuery {
    return wire($element, obs, o => o.subscribe(x => {
        if (trueClass)
            $element.toggleClass(trueClass, x);

        if (falseClass)
            $element.toggleClass(falseClass, !x);
    }));
}

export function busyWhile<T>(o: Observable<T>, $blocked: JQuery): Observable<T> {
    return Observable.using(() => {
        let busy = blockBusy($blocked);
        return ({
            unsubscribe: () => busy.dispose()
        })
    }, () => o);
}

export function messageWhen<T>(o: Observable<T>, events: IEventAggregator, messageBefore: () => Event, messageAfter: () => Event): Observable<T> {
    return Observable.using(() => {
        if (messageBefore)
            events.publish(messageBefore());

        return ({
            unsubscribe: () => {
                if (messageAfter)
                    events.publish(messageAfter());
            }
        });
    }, () => o);
}

export function bindAttribute<T>($element: JQuery, obs: Observable<T>, attributeName: string): JQuery {
    return wire($element, obs, o => o.subscribe(x => $element.attr(attributeName, <any>x)));
}

export function bindCss($element: JQuery, obs: Observable<string>, propertyName: string): JQuery {
    return $element.owns(obs.subscribe(x => $element.css(propertyName, x)));
}

export function bindText($element: JQuery, value: string | Observable<string>): JQuery {
    return value instanceof Observable
        ? wire($element, value, o => o.subscribe(x => $element.text(x)))
        : $element.text(value);
}

export function bindVal($element: JQuery, value: string | Observable<string>): JQuery {
    return value instanceof Observable
        ? wire($element, value, o => o.subscribe(x => $element.val(x)))
        : $element.val(value);
}

export function bindHeight($element: JQuery, obs: Observable<number>): JQuery {
    return wire($element, obs, o => o.subscribe(x => $element.height(x)));
}